import angular from 'angular';
import Home from './home/home';
import Landingpage from './landingpage/landingpage';
import ViewPayBill from './viewpaybill/viewpaybill';
import ScrollingList from './scrollingList/scrollingList';
import Subnav from './subnav/subnav';
import Viewpaybilllanding from './landingpage/viewpaybilllanding/viewpaybilllanding';
import Videobilllanding from './landingpage/videobilllanding/videobilllanding';
import Paperlessbillinglanding from './landingpage/paperlessbillinglanding/paperlessbillinglanding';
import Optimumidslanding from './landingpage/optimumidslanding/optimumidslanding';
import Tutorialslanding from './landingpage/tutorialslanding/tutorialslanding';
import Suddenlinkidslanding from './landingpage/suddenlinkidslanding/suddenlinkidslanding';
import Paperlessbilling from './paperlessbilling/paperlessbilling';
import Keyboard from './keyboard/keyboard';
import Optimumids from './optimumids/optimumids';
import Suddenlinkids from './suddenlinkids/suddenlinkids';
import Optimumidlist from './optimumidlist/optimumidlist';
import Tutorials from './tutorials/tutorials';
import Tutoriallist from './tutoriallist/tutoriallist';
import VideoTutorials from './videotutorials/videotutorials';
import Faq from './faq/faq';
import FaqLanding from './landingpage/faqlanding/faqlanding';
import FaqTemplate from './faqtemplate/faqtemplate';
import VideoPlayer from './videoplayer/videoplayer';
import Player from'./player/player';

let componentModule = angular.module('app.components', [
  Home.name,
  Landingpage.name,
  ViewPayBill.name,
  ScrollingList.name,
  Subnav.name,
  Viewpaybilllanding.name,
  Videobilllanding.name,
  Paperlessbillinglanding.name,
  Optimumidslanding.name,
  Tutorialslanding.name,
  Suddenlinkidslanding.name,
  Paperlessbilling.name,
  Keyboard.name,
  Optimumids.name,
  Suddenlinkids.name,
  Optimumidlist.name,
  Tutorials.name,
  Tutoriallist.name,
  VideoTutorials.name,
  Faq.name,
  FaqLanding.name,
  FaqTemplate.name,
  VideoPlayer.name,
  Player.name
]);

export default componentModule;



// WEBPACK FOOTER //
// ./client/app/components/components.js